import React, { useRef, useState, useEffect, useMemo } from "react";
import { Checkbox, CheckboxGroup, CheckPicker, Form, Loader, Placeholder, Schema, SelectPicker } from "rsuite";
import styled from "styled-components";

import { servicePlanNoTrunkFilter } from "utils/filters";
import ServicePlans from "components/Filters/ServicePlans";
import { ButtonPrimary } from "components/base/BaseButton";
import { Alert } from "services/Alert";


const formModel = Schema.Model({
    // during: StringType().isRequired("Required")
});

// get During options
const getDuringOptions = () => {
    const duringOptions = [];
    for (let i = 0; i < 24; i++) {
        const start_time = new Date(0, 0, 0, i);
        const end_time = new Date(0, 0, 0, i + 1);

        duringOptions.push({
            dr_key: `${start_time.toLocaleTimeString("it-IT")}-23:59:59`,
            dr_name: `${start_time.toLocaleTimeString(["it-IT"], { hour: "2-digit", minute: "2-digit" })} - ${end_time.toLocaleTimeString(["it-IT"], { hour: "2-digit", minute: "2-digit" })} GMT`
        });
    }

    return duringOptions;
};


const AccessListFiltersSettings = ({ settings, ...props }) => {
    const formRef = useRef(null);

    const [isDaily, setIsDaily] = useState(false);
    const [loading, setLoading] = useState(false);

    const defaultFilters = useMemo(() => {
        if (!settings) {
            return null;
        }

        const start_time = settings.start_time;

        return {
            ...settings,
            daily: settings.daily ? [true] : [],
            appearance: settings.appearance ? [true] : [],
            during: `${start_time}-23:59:59`,
            prices: settings.prices
        };
    }, [settings]);

    const [formValue, setFormValue] = useState(defaultFilters);

    useEffect(() => {
        setFormValue(defaultFilters);
        setIsDaily(!!settings?.daily);
    }, [defaultFilters, settings]);

    if (!settings) {
        return <>
            <div style={{ height: 106, position: "relative" }}>
                <Loader backdrop content="loading..." vertical />
                <Placeholder.Paragraph />
            </div>
        </>;
    }

    const handleChange = (value) => {
        const isDaily = value.daily && value.daily.length ? true : false;
        setIsDaily(isDaily);
        setFormValue(value);
    };

    const handleApply = () => {
        if (formRef.current?.check()) {

            setLoading(true);

            const formValues = formValue || {};

            //get time values
            const during = formValues["during"];
            let start_time = "00:00:00";
            let end_time = "23:59:59";
            if (during) {
                [start_time, end_time] = during.split("-");
            }

            const newData = {
                daily: formValues.daily && formValues.daily.length ? true : false,
                appearance: formValues.appearance && formValues.appearance.length ? true : false,
                sp_key_list: formValues.sp_key_list ? formValues.sp_key_list : [],
                start_time: start_time,
                end_time: end_time,
                type: formValues.type ? formValues.type : 2
            };

            props.handleSubmit(props.accountId, newData).then((r) => {
                setLoading(false);
                Alert.success("Saved");
            });
        }
    };

    return (
        <>
            <StyledForm
                disabled={false}
                ref={formRef}
                onChange={(value) => handleChange(value)}
                formDefaultValue={defaultFilters}
                formValue={formValue}
                layout="inline"
                model={formModel}
                className="mailingSettings"
            >
                <div style={{ marginBottom: "10px" }}>
                    <Form.Group>
                        <Form.Control name="appearance" accepter={CheckboxGroup}>
                            <Checkbox value={true}> Per appearance for filtered destinations</Checkbox>
                        </Form.Control>
                    </Form.Group>
                </div>

                <Form.Group>
                    <Form.Control name="daily" accepter={CheckboxGroup}>
                        <Checkbox value={true}> Daily</Checkbox>
                    </Form.Control>
                </Form.Group>

                <Form.Group className={(isDaily ? "" : "disabled")}>
                    <Form.ControlLabel> for price</Form.ControlLabel>
                    <ServicePlans
                        accepter={CheckPicker}
                        name="sp_key_list"
                        disabled={!isDaily}
                        filtered
                        style={{ marginLeft: "12px", maxWidth: 320 }}
                        menuAutoWidth={false}
                        menuStyle={{ width: 240 }}
                        filterFunc={servicePlanNoTrunkFilter}
                    />
                </Form.Group>
                <Form.Group className={(isDaily ? "" : "disabled")}>
                    <Form.ControlLabel> During </Form.ControlLabel>
                    <Form.Control
                        name="during"
                        accepter={SelectPicker}
                        data={getDuringOptions()}
                        labelKey="dr_name"
                        valueKey="dr_key"
                        placeholder="Timing"
                        style={{ width: "180px" }}
                        searchable={false}
                        disabled={!isDaily}
                        cleanable={false}
                    />
                </Form.Group>
                <Form.Group className={(isDaily ? "" : "disabled")}>
                    <Form.ControlLabel> Type </Form.ControlLabel>
                    <Form.Control
                        name="type"
                        accepter={SelectPicker}
                        data={[
                            { tp_key: 1, tp_name: "Full price" },
                            { tp_key: 2, tp_name: "Just for allocated" },
                            { tp_key: 4, tp_name: "Only filtered destinations" }
                        ]}
                        labelKey="tp_name"
                        valueKey="tp_key"
                        placeholder="Type"
                        style={{ width: "180px" }}
                        searchable={false}
                        disabled={!isDaily}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonPrimary
                        style={{ padding: "8px 34px", marginLeft: 12 }}
                        onClick={handleApply}
                        disabled={loading || !props.showSaveButton}
                    >
                        Save
                    </ButtonPrimary>
                </Form.Group>

            </StyledForm>
        </>
    );
};

export default AccessListFiltersSettings


const StyledForm = styled(Form)`
    && {
        margin-left: 12px;
    }
`;
